export default __webpack_public_path__ + "static/media/lateef.d0ec5f10.png";